<template>
  <section class="container">
    <!-- 头部 -->
    <header class="header el-header">
      <!-- 工具条 -->
      <div class="header__action-sheet">
        <img src="@/assets/index/list.png"
             class="menuIcon"
             @click="menuShow=!menuShow;">
        <div :class="'menuList '+(menuShow?'':'hide')"
             id="menuList">
          <div :class="'menuItem '+(onRoutes()==item.name?'active':'')"
               v-for="item in menuList"
               :key="item.name">
            <router-link :to="{ name: item.name}">
              <p @click="menuShow=false;">{{item.text}}</p>
            </router-link>
          </div>
        </div>
      </div>

      <img class="header__logo"
           src="@/assets/index/logo.png"
           alt="">

      <login-btn></login-btn>

    </header>

    <!-- 主体 -->
    <section class="main">
      <transition name="fade"
                  mode="out-in">
        <router-view></router-view>
      </transition>
    </section>

  </section>
</template>

<script>
import loginBtn from "@/components/loginBtn.vue";
export default {
  name: 'index',
  components: {
    loginBtn
  },
  data () {
    return {
      menuShow: false,
      menuList: [
        {
          text: '首页',
          name: 'home'
        }, {
          text: '数据服务',
          name: 'dataExpress'
        }, {
          text: '产品方案',
          name: 'scheme'
        }, {
          text: '遥感日报',
          name: 'dailyReport'
        }, {
          text: '商务合作',
          name: 'cooperation'
        }, {
          text: '珠海一号卫星星座',
          name: 'zhuHai01'
        }
      ]
    }
  },
  // provide () {
  //   return {
  //     header: this//提供祖先组件的实例
  //   };
  // },
  methods: {
    onRoutes () {
      let defActive = this.$route.matched;
      for (let i = 0; i < defActive.length; i++) {
        for (let n = 0; n < this.menuList.length; n++) {
          if (defActive[i].name == this.menuList[n].name) {
            return defActive[i].name;
          }
        }
      }
    },
  }
}
</script>
<style lang="stylus" scoped>
.container
  width 100%
  height 100%

  .header
    position fixed
    top 0
    left 0
    display flex
    justify-content space-between
    align-items center
    width 100%
    height 60px
    padding 0 15px
    box-sizing border-box
    z-index 9

    > div
      width 62px

    &__logo
      width 62px
      height 33px

  .main
    width 100%
    height 100%

.menuIcon
  position fixed
  left 20px
  top 19px
  width 22px
  height 22px
  z-index 202

#menuList
  position fixed
  padding-top 60px
  box-sizing border-box
  left 0
  top 0
  width 160px
  height 100%
  z-index 101
  background-color rgba(0, 0, 0, 0.8)
  transition left 0.4s

  &.hide
    left -160px
    transition left 0.4s

  .menuItem.active
    background linear-gradient(90deg, rgba(52, 209, 188, 0.7) 0%, rgba(52, 209, 188, 0) 100%)

  a p
    color #fff
    font-size 14px
    height 40px
    line-height 40px
    box-sizing border-box
    width 140px
    margin 0 auto
    text-align center
    border-bottom 1px solid rgb(135, 147, 153)

.el-header.inder-header
  display flex
  position relative
  justify-content space-between
  align-items center
  background linear-gradient(0deg, rgba(0, 0, 43, 0) 0%, rgba(0, 0, 43, 0.7) 100%)
  opacity 0.8
  position fixed
  left 0
  top 0
  width 100%
  z-index 100

.el-header.scrollHeader
  background-color #061F66
  transition background 0.5s
</style>
